exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Tags__tag__3i1eMD {\n  display: inline-flex;\n  align-items: center;\n  min-width: 51px;\n  max-width: 100px;\n  height: 24px;\n  border: 1px solid #aaa;\n  border-radius: 3px;\n  font-size: 12px;\n  margin-right: 5px;\n  margin-bottom: 5px;\n}\n.Tags__removable-tag__3FmwZc {\n  display: inline-flex;\n  align-items: center;\n  min-width: 51px;\n  max-width: 100px;\n  height: 24px;\n  border: 1px solid #aaa;\n  border-radius: 3px;\n  font-size: 12px;\n  margin-right: 5px;\n  margin-bottom: 5px;\n}\n.Tags__removable-tag__3FmwZc:hover {\n  background-color: #ebebeb;\n}\n.Tags__removable-tag__3FmwZc .Tags__tag-label__3CHCGj {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 50px;\n  pointer-events: none;\n  overflow: hidden;\n}\n.Tags__removable-tag__3FmwZc .Tags__close-btn__3iXyZY {\n  font-size: 18px;\n  text-align: center;\n  cursor: pointer;\n  color: #aaa;\n  width: 22px;\n  height: 24px;\n  border-right: 1px solid #aaa;\n}\n.Tags__removable-tag__3FmwZc .Tags__close-btn__3iXyZY:hover {\n  color: #777676;\n}\n", ""]);

// exports
exports.locals = {
	"tag": "Tags__tag__3i1eMD",
	"removable-tag": "Tags__removable-tag__3FmwZc",
	"tag-label": "Tags__tag-label__3CHCGj",
	"close-btn": "Tags__close-btn__3iXyZY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/src??ref--2-2!./node_modules/stylus-loader!./web_modules/trustar/components/Tags.styl
// module id = 3648
// module chunks = 39